import { replacePathParams } from '@/api/utils';

export const composerApiPaths = {
  caseDeviceTracking: '/apicomposer/case-device-tracking/:caseId',
  caseDeviceTrackingCustomer: '/apicomposer/case-device-tracking/:caseId/customer',
  bulkArrival: '/apicomposer/case-device-tracking/bulk-arrival',
  bulkArrivalCustomer: '/apicomposer/case-device-tracking/bulk-arrival/customer',
} as const;

export const getComposerApiUrl = {
  caseDeviceTracking: (caseId: string) => replacePathParams(composerApiPaths.caseDeviceTracking, { caseId }),
  caseDeviceTrackingCustomer: (caseId: string) =>
    replacePathParams(composerApiPaths.caseDeviceTrackingCustomer, { caseId }),
  bulkArrival: () => composerApiPaths.bulkArrival,
  bulkArrivalCustomer: () => composerApiPaths.bulkArrivalCustomer,
};
